// extracted by mini-css-extract-plugin
export default {"bold":"ReinforcementSummary_bold__FQUru","row":"ReinforcementSummary_row__f1HdB","table":"ReinforcementSummary_table__-UvLK","min120":"ReinforcementSummary_min120__jbY+D"};